import React, { useEffect, useState } from "react";
import "./referenzen.css";
import { getReferences } from "../../Transformations/NewsList";

import LogoLoad from "../../../images/logo/logo-loader.svg";

export default function Referenzen() {
	const [referenceData, setReferenceData] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getReferences();
			setReferenceData(data);
		};

		fetchData();
	}, []);

	return (
		<div className="referenc-page">
			<h2>Ausgewählte Referenzen</h2>
			<div className="referenc-list">
				{referenceData ? (
					referenceData.map((reference, index) => {
						return (
							<div className="reference-card" key={index}>
								<img src={reference.logo} />
								<span>{reference.name}</span>
							</div>
						);
					})
				) : (
					<div className="loading-page">
						<div className="loader"></div>
						<img className="load-img" src={LogoLoad} alt="Loading" />
					</div>
				)}
			</div>
		</div>
	);
}
